import { menuVisibleBus } from '@/event/menuVisibleBus'

export function toggleMenu() {
  menuVisibleBus.value = !menuVisibleBus.value
}
